module.exports = __webpack_public_path__ + "static/img/loginLogo.c21916c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginLogo.png
// module id = Zx/2
// module chunks = 1